import styled from "styled-components";

export const Container = styled.div`
	display: flex;
	flex-direction: column;

	position: relative;

	height: 95%;
	width: 25%;

	border-radius: 0.5rem;

	padding: 1rem;

	background-color: white;

	box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);

	.hidden {
		display: none;
	}

	.show {
		display: flex;
	}
`;

export const Content = styled.div`
	width: 100%;
	height: 100%;

	.process-details {
		width: 100%;
		height: 100%;

		background-color: white;
	}

	.process-prop-name {
		display: flex;
		flex-direction: column;

		height: 6rem;

		justify-content: space-evenly;
	}

	#doc-line {
		border: 1px solid #e7e7e7;

		margin: 1rem 0 1rem 0;
	}

	.prop-info {
		font-size: 1rem;
		font-weight: 700;

		margin-top: 10px;
		margin-bottom: 10px;

		color: #2d7bbc;
	}

	#prop-name {
		color: #2d7bbc;

		font-size: 1.2rem;
		font-weight: 700;

		text-transform: capitalize;
	}

	.prop-cpf {
		font-size: 0.9rem;
		font-weight: 700;

		color: #2d7bbc;
	}

	.docs-container {
		display: flex;
		flex-direction: column;

		width: 100%;
		max-height: 200px;
		padding: 1rem 0;
		gap: 1.5rem;

		overflow-y: auto;
	}

	.doc-wrapper,
	.missing-docs {
		display: flex;

		width: 98%;
		height: 2.5rem;

		border: 1px solid #e7e7e7;
		border-radius: 0.25rem;

		background-color: #f5f5f5;

		box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25);

		align-items: center;
		justify-content: center;

		padding: 1rem;

		background-color: #f3f3f3;

		cursor: pointer;
	}

	.doc-wrapper {
		justify-content: space-between;
	}

	#missing {
		width: 100%;

		margin-top: 1rem;

		font-weight: 500;
	}

	.doc-title,
	.doc-input {
		font-size: 1rem;

		max-width: 200px;

		color: #2d7bbc;

		background-color: none;
		border: none;

		letter-spacing: 0;

		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.icons-wrapper {
		display: flex;

		width: 30%;

		justify-content: space-between;
	}

	.icon,
	.title-wrapper {
		display: flex;
		height: 100%;

		align-items: center;

		gap: 0.5rem;
	}

	.svg {
		width: 1.25rem;
		height: 1.25rem;
	}

	.icon-text {
		color: #394ae0;

		font-size: 1.1rem;
	}

	.missing-docs {
		justify-content: center;

		transition: 0.25s;

		color: #2d7bbc;

		font-size: 1.2rem;
	}

	.missing-docs:hover,
	.doc-wrapper:hover {
		font-size: 1.25rem;

		background-color: white;
	}
`;

export const ContentMessage = styled.div`
	display: flex;
	width: 20rem;
	min-width: 14rem;
	padding: 1rem;
	background: #e9e7f4;
	box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
	border-radius: 0.5rem;

	font-family: "Roboto";
`;
